import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class IdiolTimeoutServiceService {

  private idleTimeout: any;
  private timeoutDuration = 30 * 60 * 1000;  // 2 minutes
  private warningDuration = 0 * 1000; // Warning 30 seconds before timeout

  constructor(private authService: AuthService, private router: Router, private ngZone: NgZone) { }
  startMonitoring(): void {
    this.resetTimeout();

    // Monitor mouse and keyboard activity
    fromEvent(document, 'mousemove')
      .pipe(debounceTime(500)) // Wait 500ms before triggering
      .subscribe(() => this.resetTimeout());

    fromEvent(document, 'keydown')
      .pipe(debounceTime(500))
      .subscribe(() => this.resetTimeout());
  }

  private resetTimeout(): void {
    // Clear any previous timeout and set a new one
    if (this.idleTimeout) {
      clearTimeout(this.idleTimeout);
    }

    // Check if session is valid 30 seconds before timeout
    this.idleTimeout = setTimeout(() => {
      this.authService.validateSession();
      this.ngZone.run(() => {
        sessionStorage.removeItem('authToken');
        this.router.navigate(['/login']);
      });

    }, this.timeoutDuration); // Warning 30 seconds before timeout
  }
}
